import ApiClient from './ApiClient';

const apiClient = ApiClient('/dashboard');

export const getDashboard = (onSuccess, onError, onDone) => {
    apiClient.get('/').then(onSuccess).catch(onError).finally(onDone);
};
